
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe15 as ObiHydraulicPipe15Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-15.js';
 
 
 

 
 export const ObiHydraulicPipe15 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-15',
   elementClass: ObiHydraulicPipe15Element,
   events: {
     
   }
  });
 
 